import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsFetchingAgent, selectTriggerAgent, selectTriggerAgentTools } from 'store/Agents/selectors';
import Tool from './Tool';
import { Title, Wrapper, Body } from './styled';
import SpinnerComponent from 'Common/Components/SpinnerContainer';

const Tools = ({ toolToSave, setToolToSave, setTriggerWarning, toolExpanded, setToolExpanded }) => {
  const isFetching = useSelector(selectIsFetchingAgent);
  const agentSelected = useSelector(selectTriggerAgent);
  const tools = useSelector(selectTriggerAgentTools);
  const [toolsList, setToolsList] = useState(tools);

  useEffect(() => {
    setToolsList(tools);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agentSelected?.id, tools]);

  return (
    <Wrapper>
      <Title>Tools</Title>
      { isFetching
        ? <SpinnerComponent />
        : <Body>
            { toolsList
              ? toolsList.map((tool) =>
              <Tool
                key={ tool.id }
                tool={ tool }
                defaultValue={ false }
                toolToSave={ toolToSave }
                setToolToSave={ setToolToSave }
                setTriggerWarning={ setTriggerWarning }
                toolExpanded={ toolExpanded }
                setToolExpanded={ setToolExpanded }
              />)
              : null }
          </Body>
      }

    </Wrapper>
  );
};

export default Tools;
